import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFormSeal: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="form-seal, badge"><g clipPath="url(#clip0_14456_27902)"><path d="M19.175 4.825H15.075L12 1.75L8.925 4.825H4.825V8.925L1.75 12L4.825 15.075V19.175L8.925 19.2481L12 22.25L15.075 19.2481H19.175V15.075L22.25 12L19.175 8.925V4.825Z" stroke="currentColor" strokeWidth="1.5"/></g><defs><clipPath id="clip0_14456_27902"><rect width="24" height="24" fill="white"/></clipPath></defs></CentralIconBase>;
};

export default IconFormSeal;
